import { RENDER_CONSTS } from '../config/constants'
import { Spell } from '../redux/models'

type Props = {
    spell: Spell
    onClick: (spell: Spell) => void
}

export const SpellRow = (props: Props): JSX.Element | null => {
    return (
        <div
            style={{
                width: "185px",
                height: RENDER_CONSTS.ROW_HEIGHT,
                cursor: 'pointer'
            }}
            className="d-flex align-items-center border-dark px-2 border border-top-0"
            onClick={() => {
                props.onClick(props.spell)
            }}
        >
            {props.spell.name}
        </div>
    )
}